// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsergroupDeleteOutlinedSvg from "@fishx/icons-svg/es/asn/UsergroupDeleteOutlined";
import FishxIcon from '../components/FishxIcon';

var UsergroupDeleteOutlined = function UsergroupDeleteOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsergroupDeleteOutlinedSvg
  }));
};

UsergroupDeleteOutlined.displayName = 'UsergroupDeleteOutlined';
export default React.forwardRef(UsergroupDeleteOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UsergroupDeleteOutlined.js
// module id = 4358
// module chunks = 0